export default __webpack_public_path__ + "static/media/gigLogoBlue.580fd4d7.svg";